module.exports = __webpack_public_path__ + "static/media/illustration-section-09.a52f7800.svg";